angular.module('relivConference').directive(
    'relivConferenceRibbonsDirective',
    function () {
        return {
            scope: {
                relivConferenceRibbonsDirective: '=',
            },
            link: function (scope, element, attrs) {
                scope.ribbons = scope.relivConferenceRibbonsDirective;
            },
            template: '' +
            '<div ng-repeat="(key, ribbon) in ribbons" class="">' +
            ' <div class="btn-group" role="group" ng-show="ribbon.has">' +
            '  <div ng-style="{\'background-color\': ribbon.color}" ng-class="{ defaultBackgroundColor: ribbon.color == null}" class="ribbon col-sm-12">' +
            '   <div class="ribbon-name">{{ribbon.name}}</div>' +
            '  </div>' +
            ' </div>' +
            '</div>',
        };
    }
);
